import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Box, Col, Container, Flex, Row } from '../grid';
import { formatTableHeaders, mapSpacedData, removeTypeName } from '../../utils/tables';
import { HeadingWithLineHighlights } from '../heading-with-line-highlights';
import { RichText, Subheading } from '../typography';
import { SpacedTable } from '../table-template/spaced-table';
import { Table } from '../table-template/table';

const ProductDetails = ({ additionalInformationTable, body, heading, nutritionalInformationTable, subheading }) => {
  const additionalInformationData = map(additionalInformationTable, ({ additionalInfo, description }) => {
    return mapSpacedData(additionalInfo, description, true, false);
  });

  return (
    <Container py={1}>
      <Flex my={2} flexDirection="column" justifyContent="center" alignItems="center">
        <HeadingWithLineHighlights {...{ heading }} />
      </Flex>
      <Row>
        <Col width={{ xs: 12 / 12, md: 10 / 12 }} offset={[0, 0, 1 / 12]}>
          <Table
            data={removeTypeName(nutritionalInformationTable)}
            headers={formatTableHeaders(nutritionalInformationTable, ['__typename'])}
          />
          {body && (
            <Box py="1rem">
              <Subheading pb="1rem" variant={2}>
                {subheading}
              </Subheading>
              <RichText keepMargins>{body}</RichText>
            </Box>
          )}
          <SpacedTable
            data={additionalInformationData}
            detailWidth="100%"
            headers={formatTableHeaders(additionalInformationTable, ['description', '__typename'])}
          />
        </Col>
      </Row>
    </Container>
  );
};

ProductDetails.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  body: PropTypes.string,
  nutritionalInformationTable: PropTypes.arrayOf(
    PropTypes.shape({
      nutritionalInfo: PropTypes.string,
      avgQtyPerServing: PropTypes.string,
      avgQtyPer100g: PropTypes.string,
    })
  ).isRequired,
  additionalInformationTable: PropTypes.arrayOf(
    PropTypes.shape({
      additionalInfo: PropTypes.string,
      description: PropTypes.string,
    })
  ).isRequired,
};

ProductDetails.defaultProps = {
  body: null,
};

export { ProductDetails };
